import axios from '../axios/index.js'

export default {
    list(data){
        return axios.get('/mail_server/list',{ params:data })
    },
    getStatusList(payload){
        return axios.get('/mail_server/getStatusList',{ params:payload })
    },
}
